module.exports = __webpack_public_path__ + "static/media/React.bcb5dbb3.jpg";